import * as Sentry from '@sentry/nuxt';

import { StorageKey } from '~/utils/storage';

export default defineNuxtRouteMiddleware((to, _from) => {
  if (import.meta.server) return;

  Sentry.setContext('route', { name: to.name as string, path: to.path });

  const accessToken = getItemStorage(StorageKey.ACCESS_TOKEN);
  const isLoggedIn = !!accessToken;

  const { $auth } = useNuxtApp();

  if (isLoggedIn && $auth.isGuestOnlyRoute(to.path)) {
    return navigateTo($auth.getProfilePath(), { external: true });
  }

  if (!isLoggedIn && $auth.isAuthRequired(to.path)) {
    return navigateTo($auth.getLoginPath(), { external: true });
  }
});
